Librarian.Window = new Class({
    Extends: MUI.Window,
    Binds: ["onWindowLoaded", "onToolbarLoaded", "onToolbar2Loaded", "onFooterLoaded",
            "onKeyPressed", "onResize", "onMaximize", "onClose", "close",
            "addEvents", "removeEvents"],

    options: {
        id: '',
        minimizable: false,
        maximizable: false,
        resizable: false,
        toolbarHeight: 40
    },

    initialize: function(options) {
        this.setOptions(options);

        if (this.options.type === "modal") {

            if(!$("modalOverlay")) {

                // initialize modal overlay
                this.modalInitialize();             

                // set overlay size on window resize
                window.addEvent("resize", function() {
                    this.setModalSize();
                    this.onResize();
                }.bind(this));

            }
        }

        // If we don't already have a onContentLoaded function, use our onWindowLoaded as the default
        if ((typeof this.options.onContentLoaded != "function") || (this.options.onContentLoaded == $empty))
            this.options.onContentLoaded = this.onWindowLoaded;

        // If we don't already have a toolbarOnload function, use our onToolbarLoaded as the default
        if ((typeof this.options.toolbarOnload != "function") || (this.options.toolbarOnload == $empty))
            this.options.toolbarOnload = this.onToolbarLoaded;

        if ((typeof this.options.toolbar2Onload != "function") || (this.options.toolbar2Onload == $empty))
            this.options.toolbar2Onload = this.onToolbar2Loaded;

        if ((typeof this.options.footerOnload != "function") || (this.options.footerOnload == $empty))
            this.options.footerOnload = this.onFooterLoaded;

        // Add and remove events when gaining and losing focus, as well as when the window is closed
        // but don't overwrite functions if the child classes already set them
        if ((typeof this.options.onClose != "function") || (this.options.onClose == $empty))
            this.options.onClose = this.onClose;
        if ((typeof this.options.onBlur != "function") || (this.options.onBlur == $empty))
            this.options.onBlur = this.removeEvents;
        if ((typeof this.options.onFocus != "function") || (this.options.onFocus == $empty))
            this.options.onFocus = this.addEvents;
        if ((typeof this.options.onResize != "function") || (this.options.onResize == $empty))
            this.options.onResize = this.onResize;
        if ((typeof this.options.onMaximize != "function") || (this.options.onMaximize == $empty))
            this.options.onMaximize = this.onMaximize;
        if ((typeof this.options.onRestore != "function") || (this.options.onRestore == $empty))
            this.options.onRestore = this.onRestore;

        if (typeof this.options.contentURL == "string")
            this.options.contentURL = this.addVersion(this.options.contentURL);
        if (typeof this.options.toolbarURL == "string")
            this.options.toolbarURL = this.addVersion(this.options.toolbarURL);
        if (typeof this.options.toolbar2URL == "string")
            this.options.toolbar2URL = this.addVersion(this.options.toolbar2URL);
        if (typeof this.options.footerURL == "string")
            this.options.footerURL = this.addVersion(this.options.footerURL);

        this.parent(this.options);

    },

    addVersion: function(url) {
        if (url.contains('?' + Librarian.buildVersion) || url.contains('&' + Librarian.buildVersion))
            return url;

        if (url.contains('?'))
            url += '&';
        else
            url += '?';

        return url + Librarian.buildVersion;
    },

    addEvents: function() {
        document.addOnKeyPress(this.onKeyPressed, this);
    },

    removeEvents: function() {
        document.removeOnKeyPress();
    },

    onClose: function() {
        this.removeEvents();
    },

    onKeyPressed: function(event) {
        // ESC closes the window
        if (event.key == "esc") {
            MUI.closeWindow($(this.options.id));
            event.stop();
        }
    },

    onWindowLoaded: function() {
        // Resize in case window is too big for the screen
        this.resize({ centered: true });
        this.handlePositionLimits();

        Librarian.Lang.translateElements(this.windowEl);
    },

    onToolbarLoaded: function () {
        Librarian.Lang.translateElements(this.windowEl);
    },

    onResize: function () {
        if (this.options.type == "modal")
            MUI.centerWindow($(this.options.id));
    },

    onRestore: function() {
    },

    onMaximize: function() {
    },

    updateTitle: function() {
        // Set the displayed text on the title bar
        var itemEl = $(this.options.id + "_title");
        if (itemEl) {
            var width = this.options.width;
            if (this.isMaximized)
                width = window.getWidth();

            itemEl.set("text", MUI.getFittedTitle(this.options.title, width));
            itemEl.title = this.options.title;
        }

        // Update the title of the dock tab for hover over
        itemEl = $(this.options.id + "_dockTab");
        if (itemEl)
            itemEl.title = this.options.title;

        // Update the text inside of the dock tab
        itemEl = $(this.options.id + "_dockTabText");
        if (itemEl)
            itemEl.set("text", this.options.title.substring(0, 19) + (this.options.title.length > 19 ? "..." : ''));
    },

    resize: function(options) {
        var defaults = {
            width: this.options.width,
            height: this.options.height
        };

        options = Object.merge(defaults, options);

        if (options.height == "auto") {
            this.windowEl.addClass("resizing");
            options.height = this.contentEl.scrollHeight;
            this.windowEl.removeClass("resizing");
        }

        // Make sure window fits in the page
        var docSize = document.getSize();
        var maxWidth = docSize.x - 20;
        var maxHeight = docSize.y - 20;

        maxHeight = maxHeight - this.options.headerHeight - this.options.footerHeight;

        if (this.options.toolbar)
            maxHeight -= this.options.toolbarHeight;

        if (this.options.toolbar2)
            maxHeight -= this.options.toolbar2Height;

        options.width = Math.min(options.width, maxWidth);
        options.height = Math.min(options.height, maxHeight);

        this.options.width = options.width;
        this.options.height = options.height;

        this.parent(options);
    },

    setupElements: function(elems) {
        if (!elems) {
            elems = this.contentEl.getElements('[id]');
            if (this.toolbarEl)
                elems = elems.concat(this.toolbarEl.getElements('[id]'));
            if (this.toolbar2El)
                elems = elems.concat(this.toolbar2El.getElements('[id]'));
        }

        for (var i = 0; i < elems.length; i++) {
            var elem = $(elems[i]);
            // Only change the id if it has one and it hasn't already been changed
            if (elem && elem.id && !elem.id.startsWith(this.options.id + '_'))
                elem.id = this.options.id + '_' + elem.id;
        }
    },

    getElement: function(elemId) {
        return this.windowEl.getElement('#' + this.options.id + '_' + elemId) || this.windowEl.getElement('#' + elemId);
    },

    getElements: function(selector) {
        return this.windowEl.getElements(selector);
    },

    /* Modal Methods */
    modalInitialize: function() {
        var modalOverlayEl = new Element("div", {
            "id": "modalOverlay",
            "styles": {
                "height": document.getCoordinates().height,
                "opacity": .6
            }
        }).inject(document.body);

        modalOverlayEl.setStyles({
            "position": Browser.Engine.trident4 ? "absolute" : "fixed"
        });

        modalOverlayEl.addEvent(getTouchOrMouseEvent("click"), function() {
            var instance = MUI.Windows.instances.get(MUI.currentModal.id);
            if (instance && (instance.options.modalOverlayClose == true)) {
                MUI.closeWindow(MUI.currentModal);
            }
        });

        if (Browser.Engine.trident4) {
            new Element("iframe", {
                "id": "modalFix",
                "scrolling": "no",
                "marginWidth": 0,
                "marginHeight": 0,
                "src": '',
                "styles": {
                    "height": document.getCoordinates().height
                }
            }).inject(document.body);
        }

        MUI.Modal.modalOverlayOpenMorph = new Fx.Morph($("modalOverlay"), {
            "duration": 150
        });
        MUI.Modal.modalOverlayCloseMorph = new Fx.Morph($("modalOverlay"), {
            "duration": 150,
            onComplete: function() {
                $("modalOverlay").hide();
                if (Browser.Engine.trident4)
                    $("modalFix").hide();
            }.bind(this)
        });
    },

    setModalSize: function() {
        $("modalOverlay").setStyle("height", document.getCoordinates().height);
        if (Browser.Engine.trident4)
            $("modalFix").setStyle("height", document.getCoordinates().height);
    }
});